import { render, staticRenderFns } from "./GBtableListPop.vue?vue&type=template&id=31f1ab24"
import script from "./GBtableListPop.vue?vue&type=script&lang=js"
export * from "./GBtableListPop.vue?vue&type=script&lang=js"
import style0 from "./GBtableListPop.vue?vue&type=style&index=0&id=31f1ab24&prod&lang=stylus"
import style1 from "./GBtableListPop.vue?vue&type=style&index=1&id=31f1ab24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports